import { style } from '@vanilla-extract/css';

import { FOCUS_OUTLINE, tokens } from './tipJarTheme.css';

export const feeCover = style({
  border: `1px solid ${tokens.line}`,
  borderRadius: tokens.fieldRadius,
  background: tokens.surface,
});

export const option = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 14px',
  fontSize: '14px',
  lineHeight: '20px',
  cursor: 'pointer',
});

export const checkbox = style({
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
});

export const box = style({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  boxSizing: 'border-box',
  border: `1.5px solid ${tokens.faint}`,
  borderRadius: `min(6px, ${tokens.fieldRadius})`,
  background: tokens.surface,
  color: tokens.onPrimary,
  transition: 'background-color 150ms ease, border-color 150ms ease',
  selectors: {
    [`${option}:hover &`]: { borderColor: tokens.muted },
    [`${checkbox}:checked + &`]: { borderColor: tokens.primary, background: tokens.primary },
    [`${checkbox}:focus-visible + &`]: FOCUS_OUTLINE,
  },
});

export const label = style({
  flex: 1,
});

export const fee = style({
  fontWeight: 500,
  whiteSpace: 'nowrap',
  color: tokens.muted,
  fontVariantNumeric: 'tabular-nums',
});
